// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Font */

body {
    font-family: "Inter", Tahoma;
}

/* Root */
:root {
    --primary-light: #e6f2fa;
    --primary-light-hover: #d9ebf7;
    --primary-light-active: #b1d5ee;
    --primary-normal-light: #02a6e5;
    --primary-normal: #0378c9;
    --primary-normal-hover: #036cb5;
    --primary-normal-active: #0260a1;
    --primary-dark: #025a97;
    --primary-dark-hover: #024879;
    --primary-dark-active: #01365a;
    --primary-darker: #012a46;
    /* Grey */
    --grey-light: #f2f2f2;
    --grey-light-hover: #ececec;
    --grey-light-active: #d8d8d8;
    --grey-normal: #808080;
    --grey-normal-hover: #737373;
    --grey-normal-active: #666666;
    --grey-dark: #606060;
    --grey-dark-hover: #4d4d4d;
    --grey-dark-active: #3a3a3a;
    --grey-darker: #2d2d2d;
    /* Error */
    --error-light: #fbe7e7;
    --error-light-hover: #f9dbdb;
    --error-light-active: #f3b5b5;
    --error-normal: #d80f0f;
    --error-normal-hover: #c20e0e;
    --error-normal-active: #ad0c0c;
    --error-dark: #a20b0b;
    --error-dark-hover: #820909;
    --error-dark-active: #610707;
    --error-darker: #4c0505;
    /* successful */
    --successful-light: #e7feec;
    --successful-light-hover: #dbfde3;
    --successful-light-active: #b5fac4;
    --successful-normal: #10f041;
    --successful-normal-hover: #0ed83b;
    --successful-normal-active: #0dc034;
    --successful-dark: #009f22;
    --successful-dark-hover: #0a9027;
    --successful-dark-active: #076c1d;
    --successful-darker: #065417;
    /* White */
    --white-light: #ffffff;
    --white-light-hover: #ffffff;
    --white-light-active: #ffffff;
    --white-normal: #ffffff;
    --white-normal-hover: #e6e6e6;
    --white-normal-active: #cccccc;
    --white-dark: #bfbfbf;
    --white-dark-hover: #999999;
    --white-dark-active: #737373;
    --white-darker: #595959;
    /* Black */
    --black-light: #e6e6e6;
    --black-light-hover: #d9d9d9;
    --black-light-active: #b0b0b0;
    --black-normal: #000000;
    --black-normal-hover: #000000;
    --black-normal-active: #000000;
    --black-dark: #000000;
    --black-dark-hover: #000000;
    --black-dark-active: #000000;
    --black-darker: #000000;
    --black-border: #00000010;
    /* Shadow */
    --shadow-large: 0px 4px 4px 0px #0000001a;
    --shadow-2: 0px 0px 30px 0px #0000000d;
    /* buy sell colors */
    --buy-bg-color: #c9e9ff; /*var(--primary-light);*/
    --sell-bg-color: #FFCCCC /*var(--error-light-hover);*/
}

.btn-primary {
    --bs-btn-bg: var( --primary-normal);
    --bs-btn-border-color: var( --primary-normal);
    --bs-btn-hover-bg: var( --primary-normal-hover);
    --bs-btn-hover-border-color: var( --primary-normal-active);
    --bs-btn-active-bg: var( --primary-normal-active);
    --bs-btn-active-border-color: var( --primary-normal-active);
    --bs-btn-disabled-bg: var( --primary-normal);
    --bs-btn-disabled-border-color: var( --primary-normal);
}

.btn-secondary {
    --bs-btn-bg: var( --grey-normal);
    --bs-btn-border-color: var( --grey-normal);
    --bs-btn-hover-bg: var( --grey-normal-hover);
    --bs-btn-hover-border-color: var( --grey-normal-active);
    --bs-btn-active-bg: var( --grey-normal-active);
    --bs-btn-active-border-color: var( --grey-normal-active);
    --bs-btn-disabled-bg: var( --grey-normal);
    --bs-btn-disabled-border-color: var( --grey-normal);
}

.list-group {
    --bs-list-group-color: var(--bs-body-color);
    --bs-list-group-bg: var(--bs-body-bg);
    --bs-list-group-border-color: var(--grey-normal);
    --bs-list-group-border-width: 1px;
    --bs-list-group-item-padding-x: 1rem;
    --bs-list-group-item-padding-y: 0.5rem;
    --bs-list-group-active-color: var(--black-normal-active);
    --bs-list-group-active-bg: var(--white-normal);
    --bs-list-group-active-border-color: var(--white-normal);
    min-height: 45px
}


.list-group-item.active {
    border-top-color: var(--grey-light);
    border-bottom-color: var(--grey-light);
    border-top-width: 1px;
    border-bottom-width: 1px;
    vertical-align: middle
}

.list-group-item {
    border-top-color: var(--grey-light);
    border-bottom-color: var(--grey-light);
    border-top-width: 1px;
    border-bottom-width: 1px;
    border-right-width: 0px;
    border-left-width: 0px;
}

.list-group-item {
    padding: 0.7rem 0 !important;
}

.order-summary .list-group {
    min-height: auto !important
}

.order-summary .list-group-item {
    padding: 0.4rem 0 !important;
    border-top-color: var(--grey-normal) !important;
    border-bottom-color: var(--grey-light-active) !important;
}
/* Reset Elements */
ul {
    list-style: none;
    margin: 0;
    padding: 0;
}

a {
    text-decoration: none;
    color: #000;
}

button {
    background-color: transparent;
    border: none;
    padding: 0;
}

p {
    margin: 0;
}

h1,
h2,
h3,
h4,
h5,
h6 {
    margin: 0;
}

table tr:last-child td {
    border-bottom: none;
}

table thead td {
    font-weight:bold
}

.table-hover > tbody > tr:hover > * {
    --bs-table-bg-state: var(--primary-light) !important;
}

#portfolio-card #distribution-detail > div:not(:last-child), table tr:not(:last-child) td {
    border-bottom: 1px solid #0000001a;
}

.rdp-month_grid tr td {
    border-bottom: 0 !important;
}

.rounded-table {
    border-collapse: separate;
    border-spacing: 0;
    border-radius: 20px;
    -moz-border-radius: 5px;
    border-width: 1px;
    border-style: solid;
    padding: 10px
}

.card {
    border-color: #00000020 !important;
}

#right .card {
    border-color: #00000009 !important;
    box-shadow: var(--shadow-large);
}

#right .sigmago-links-card {
    border-color: #6a6a6a !important;
    background-color: #787878 !important
}

.container-clip {
    padding: 20px;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

h1-clip {
    text-align: center;
    margin-bottom: 15px;
}

.step-con {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: -0.5rem;
}

.step {
    background-color: #f5f5f5;
    border-radius: 15px;
    padding: 20px;
    width: 100%;
    font-weight: 600;
}

.step-number {
    font-size: 70px;
    font-weight: bold;
    margin-right: -10px;
    color: #333;
    background-image: linear-gradient(to right, black, #ffffff);
    color: transparent;
    background-clip: text;
    position: relative;
}

.step .description {
    font-size: 16px;
    line-height: 1.5;
    color: #333;
}

.button {
    display: block;
    width: 100%;
    padding: 15px;
    border: none;
    border-radius: 15px;
    background-color: #007bff;
    color: #fff;
    font-size: 18px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    margin-top: 0.5rem;
}

    .button:hover {
        background-color: #0069d9;
    }


.popover-contained-header {
    max-width: none !important;
    width: 400px
}

.bs-popover-bottom .arrow::after, .bs-popover-auto[x-placement^="bottom"] .arrow::after {
    border-bottom-color: #007bff !important;
}

.popover-contained-header .col-icon {
    padding: 0 !important;
    min-width: 105px;
    height: 60px;
    border: 1px solid #656565;
    text-align: center;
    vertical-align: middle
}

    .popover-contained-header .col-icon a {
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        justify-content: center;
        align-items: center;
        height: 60px;
    }

        .popover-contained-header .col-icon a:hover {
            background: repeating-radial-gradient(#3a3a3a, #6d6d6d 100px);
        }

        .popover-contained-header .col-icon a:active {
            background: #ccc;
            color: #3a3a3a
        }


.popover-contained-header .fa-2x {
    font-size: 1.7em !important
}

/*.order-modal-container {
    position: relative;
    height: 100%
}*/

/* positions the grey background relative to the parent div */
/*.custome-modal-backdrop {
    position: absolute !important;
    width: 100% !important;
}*/

.custome-modal-backdrop.show {
    opacity: 1 !important;
    background: #b5b5b536 !important;
    /* border-radius: 15px;*/
}
/* positions the modal within the parent div, but in front of the grey background */
/*.order-modal-container .modal {
    position: absolute;
}
*/
.create-alert .w-50 {
    width: 49% !important
}

.create-alert .forc-w-100 .w-50 {
    width: 99% !important
}

.react-tags {
    position: relative;
    line-height: 2;
    /* clicking anywhere will focus the input */
    cursor: text;
    z-index: 9;
}


.react-tags__selected {
    display: inline;
}

.react-tags__selected-tag {
    display: inline-block;
    box-sizing: border-box;
    border: 1px solid #D1D1D1;
    background: #F1F1F1;
    line-height: 1.2;
    /* match the font styles */
    font-size: inherit;
    height: 26px;
    margin: 0.2rem 0 0 0.2rem;
    position: absolute;
    z-index: 10;
    padding: 2px;
    border-radius: 10px
    /*line-height: inherit;*/
}


    .react-tags__selected-tag:after {
        content: '\\2715';
        color: #AAA;
    }

    .react-tags__selected-tag:hover,
    .react-tags__selected-tag:focus {
        border-color: #B1B1B1;
    }

.react-tags__search {
    display: inline-block;
    width: 100%;
}


    .react-tags__search input::-ms-clear {
        display: none;
    }

.react-tags__suggestions {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    min-width: 300px;
    font-size: 12px;
    margin-top: -1px
}


    .react-tags__suggestions ul {
        margin: 4px -1px;
        padding: 0;
        list-style: none;
        background: var(--white-light);
        border: 1px solid var(--ag-header-column-separator-color, rgba(66, 66, 66, 0.5));
        border-radius: 20px;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    }




    .react-tags__suggestions li {
        border-bottom: 1px solid var(--ag-header-column-separator-color, rgba(66, 66, 66, 0.2));
        padding: 6px 8px;
        color: var(--grey-dark);
    }

        .react-tags__suggestions li mark {
            text-decoration: underline;
            background: none;
            font-weight: bold;
            color: var(--grey-darker);
        }


        .react-tags__suggestions li:hover {
            cursor: pointer;
            background: #eee;
            color: #333;
        }

        .react-tags__suggestions li:last-child:hover {
            border-start-start-radius: 0px;
            border-start-end-radius: 0px;
        }

        .react-tags__suggestions li:first-child:hover {
            border-start-start-radius: 20px;
            border-start-end-radius: 20px;
        }

    .react-tags__suggestions ul:nth-child(0):hover {
        border-start-start-radius: 20px;
        border-start-end-radius: 20px;
    }

    /*.react-tags__suggestions #ReactTags-listbox-0 {
        border-radius: 20px;
    }*/

    .react-tags__suggestions li:hover mark {
        color: #333
    }


    .react-tags__suggestions li.is-active {
        color: var(--white-light);
        background: var(--grey-darker);
    }

        .react-tags__suggestions li.is-active:first-child {
            border-start-start-radius: 20px;
            border-start-end-radius: 20px;
        }

        .react-tags__suggestions li.is-active:last-child {
            border-start-start-radius: 0px;
            border-start-end-radius: 0px;
            border-end-start-radius: 20px;
            border-end-end-radius: 20px;
        }

        .react-tags__suggestions li.is-active mark {
            color: var(--primary-light-active)
        }

    .react-tags__suggestions li.is-disabled {
        opacity: 0.5;
        cursor: auto;
    }

.header-search .react-tags__search-input input {
    border: 0 !important;
    width: 90% !important;
    padding: 0;
    margin: 0
}

.header-search .react-tags__search-input .form-control:focus {
    box-shadow: none !important
}

.header-search .quoteListOptionsContainer .input-group-append {
    display: none
}

.header-search .react-tags__selected-tag-name {
    font-size: 13px;
    padding: 2px
}

.react-tags__suggestions li:last-child {
    border-bottom: 0;
    border-radius: 20px;
}

/**** font sizes ***/

.font-size-large {
    font-size: large
}

.font-size-xlarge {
    font-size: x-large
}

.font-size-small {
    font-size: 11px
}

.font-size-xsmall {
    font-size: x-small
}

.font-size-xxsmall {
    font-size: xx-small
}

.fs-3 {
    font-size: 1.5rem !important;
}

/**************** border rounds ********************/
.border-r10 {
    border-radius: 10px;
}

.border-r20 {
    border-radius: 20px;
}

.border-r15 {
    border-radius: 15px;
}

.border-r25 {
    border-radius: 25px;
}

.border-r40 {
    border-radius: 40px;
}


/*********** dropdown ***************/

.dropdown .btn, .dropdown .btn-check:checked + .btn, .dropdown .btn.active, .btn.show,
.dropdown .btn:first-child:active, .dropdown :not(.btn-check) + .btn:active {
    /* color: var(--bs-btn-active-color);
    background-color: var(--bs-btn-active-bg);*/
    border: none;
    border-width: 0px !important
}

.dropdown .dropdown-menu {
    --bs-dropdown-link-active-bg: var(--grey-normal-active);
}
/********* buttons style *******/
.secondary-pills-nav .nav-link, .secondary-pills-nav .btn {
    border-radius: 10px !important;
    color: var(--black-normal) !important;
    padding: 0.2rem 0.8rem !important;
    border: 1px solid var(--black-border) !important;
    margin: auto 0.2rem;
    height: auto !important;
    min-width: auto !important;
}

    .secondary-pills-nav .nav-link:hover, .secondary-pills-nav .btn-outline-secondary:hover {
        border: 1px solid var(--primary-light);
        background-color: var(--grey-light-hover);
        color: var(--primary-normal-hover) !important;
        border: 1px solid var(--primary-light) !important;
    }

    .secondary-pills-nav .nav-link.active, .secondary-pills-nav .btn-primary {
        border: 1px solid var(--primary-light);
        background-color: var(--primary-light) !important;
        color: var(--primary-normal-light) !important;
        border: 1px solid var(--primary-light) !important;
    }

.btn-outline-primary {
    border-color: var(--primary-normal);
    color: var(--black-normal);
}

    .btn-outline-primary:hover {
        background-color: var(--primary-normal-hover);
        border-color: var(--primary-normal-hover );
    }

.action-icon-btn {
    background-color: var(--primary-light);
}

    .action-icon-btn:hover {
        background-color: var(--grey-light-hover);
        color: var(--primary-normal-hover)
    }

    .action-icon-btn:active {
        background-color: var(--primary-light-active);
    }

.primary-custome-nav .nav-link {
    border-radius: 1rem;
    padding: 1rem;
    border: 0;
    color: var(--black-normal) !important;
}

.primary-custome-nav .nav-link {
    height: auto !important
}

    .primary-custome-nav .nav-link.active {
        background-color: var(--primary-light);
    }

.bg-primary {
    background-color: var(--grey-light) !important;
    color: var(--black-normal);
    font-weight: 600
}
/*.btn.show,*/
.btn-check:checked + .btn, .btn.active, .btn:first-child:active,
:not(.btn-check) + .btn:active {
    background-color: var(--grey-light-active);
}

.btn.disabled, .btn:disabled, fieldset:disabled .btn {
    opacity: 0.20 !important
}
.dropdown-item.active, .dropdown-item:active {
    background-color: var(--primary-light) !important;
    color: var(--primary-normal-light) !important;
    border: 1px solid var(--primary-light) !important;
}
.navbar-brand .dropdown-item.active, .navbar-brand .dropdown-item:active {
    border:0 !important
}
    /************** AG_GRID************/
    .ag-theme-balham .ag-header {
    background-color: var(--white-normal) !important;
    border-bottom-color: var(--white-dark) !important;
}

.ag-theme-balham .ag-filter-toolpanel-header, .ag-theme-balham .ag-filter-toolpanel-search,
.ag-theme-balham .ag-status-bar, .ag-theme-balham .ag-header-row,
.ag-theme-balham .ag-multi-filter-group-title-bar {
    font-weight: normal !important;
    color: rgba(0, 0, 0, 0.90) !important;
    color: var(--black-normal) !important;
}

.ag-theme-balham .ag-row-odd {
    background-color: var(--white-light) !important
}

.ag-theme-balham .ag-row {
    border: 1px
}

.ag-theme-balham .ag-cell {
    border: none !important
}

/*.ag-theme-balham .ag-cell {*/
/* border-right: 1px solid rgb(203, 206, 217) !important; */
/*}

.ag-theme-balham-dark .ag-cell {
    border-right: 1px solid #5c5c5c !important;
}

.ag-theme-balham .ag-cell {*/
/*border-right: 1px solid #d9dcde !important;    */
/*border-right: 1px solid #cbced9 !important;
}*/

.ag-react-container {
}

    .ag-react-container div,
    .ag-react-container span,
    .ag-cell {
        align-content: center;
    }

.aggrid-button .btn-sm {
    font-size: inherit;
    padding: 3px 9px;
}

.aggrid-button > .btn + .btn {
    margin-left: 2px;
    margin-right: 2px
}

/* Custom Classes */
.line-clamp-1 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
}

.line-clamp-2 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}

input[type="date"]::-webkit-calendar-picker-indicator,
input[type="date"]::-ms-clear,
input[type="date"]::-moz-clear {
    display: none;
}

/********* keyboard *********/
.hg-theme-default {
}

/********* check box ********/
.form-check-input:checked {
    background-color: var(--primary-normal);
    border-color: var(--primary-normal);
}

.hg-theme-default .hg-button {
    height: 30px !important;
    border: 1px solid;
    border-color: var(--grey-normal) !important
}

/**** buy sell style******/

.btn-buy {
    background: var(--buy-bg-color) !important;
    color: #000 !important;
    font-weight: 600;
    border-radius: 15px;
    box-shadow: var(--shadow-2);
    border: 0px
}

.btn-sell {
    background: var(--sell-bg-color) !important;
    color: #000 !important;
    font-weight: 600;
    border-radius: 15px;
    box-shadow: var(--shadow-2);
    border: 0px
}

table .buyRow td {
    background-image: linear-gradient(to bottom, var(--buy-bg-color), #c9e9ff99) !important;
}

table .sellRow td {
    background-image: linear-gradient(to bottom, var(--sell-bg-color), #ffcccc99) !important;
}

.custome-order-type-buy {
    /*background: var(--buy-bg-color);*/
    border: 2px solid var(--buy-bg-color) !important;
    padding-top: 0.3rem;
    padding-bottom: 0.3rem;
    padding-left: 2.35rem !important;
    border-radius: 0.45rem;
    font-weight: bold;
    opacity: 0.85
}

.custome-order-type-sell {
    /*background: var(--sell-bg-color);*/
    border: 2px solid var(--sell-bg-color) !important;
    padding-top: 0.3rem;
    padding-bottom: 0.3rem;
    padding-left: 2.35rem !important;
    border-radius: 0.45rem;
    font-weight: bold;
    opacity: 0.85;
}

.combo-selected .custome-order-type-buy {
    background: var(--buy-bg-color) !important;
    color: var(--black-normal);
    font-weight: bold;
    opacity: 1
}

.combo-selected .custome-order-type-sell {
    background: var(--sell-bg-color) !important;
    color: var(--black-normal);
    font-weight: bold;
    opacity: 1
}
/***********************************/

.bg-primary-normal {
    background-color: var(--primary-normal) !important;
    color: var(--white-normal);
}

/* Add this to your CSS file */
.fs-aggrid {
    font-size: 12px !important
}

.ag-header-cell {
    pointer-events: none;
}

    .ag-header-cell .ag-header-cell-resize {
        pointer-events: all;
    }

    .ag-header-cell .ag-header-cell-label {
        pointer-events: all;
    }

hr {
    opacity: .10;
}

/*****  chart zoom position ********/
.canvasjs-chart-toolbar {
    left: 5px !important;
    right: auto !important;
}

/******** activity & order history list grouo item ************/
.row-list-for-cols {
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid #a9a9a9;
    background-color: #f2f2f2;
    padding: 1rem 0.5rem;
    align-content: center
}

.acc-cols-width .list-group-item {
    min-width: 5%;
}

.acc-cols-width .list-group .date {
    min-width: 5%;
    width: 10%
}

.acc-cols-width .list-group .acc-icon {
    min-width: 39px;
    width: 3%
}

.acc-cols-width .list-group .desc {
    min-width: 20%;
    width: 45%
}

.acc-cols-width .list-group .invoice {
    min-width: 20%;
    width: 15%
}

.acc-cols-width .list-group .amount {
    min-width: 10%;
    width: 15%
}

.acc-cols-width .list-group .balance {
    min-width: 10%;
    width: 15%
}

.oh-cols-width .list-group-item {
    min-width: 10.7%;
}

.oh-cols-width .list-group .large-col {
    min-width: 19.5%;
    width: 15%;
}

.oh-cols-width .list-group .small-col {
    min-width: 6.5%;
}

.oh-cols-width .list-group .acc-icon {
    min-width: 39px;
    width: 3%
}

.th-cols-width .list-group-item {
    min-width: 11%;
}

.th-cols-width .list-group .large-col {
    min-width: 19.5%;
    width: 15%;
}

.th-cols-width .list-group .small-col {
    min-width: 6.5%;
}

.th-cols-width .list-group .acc-icon {
    min-width: 39px;
    width: 3%
}

.th-cols-width-2 .list-group-item {
    min-width: 14.2%;
}

.small-modal .list-group-item {
    padding: 0.1rem !important;
}


.pf-css .dropdown {
    font-size: inherit !important;
}

.modal-content {
    font-size: 13px
}

.form-control-lg {
    font-size: 13px !important
}

.custom-keyboard .hg-button.hg-standardBtn[data-skbtn="{space}"] {
    flex-grow: 1;
}

.custom-keyboard .language-button {
    max-width: 80px;
    min-width: 80px;
    flex-grow: 0;
}

@keyframes pulse {
    0% {
        box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.7);
    }

    50% {
        box-shadow: 0 0 0 10px rgba(59, 130, 246, 0);
    }

    100% {
        box-shadow: 0 0 0 0 rgba(59, 130, 246, 0);
    }
}

.custom-keyboard .hg-activeButton {
    animation: pulse 0.5s cubic-bezier(0.4, 0, 0.6, 1) !important;
    border-color: #3b82f6 !important;
    background-color: #036cb5 !important;
    color: #fff
}


.language-button span {
    filter: grayscale(1);
}

.move_money .tabSelector .active:first-child {
    background-color: var(--primary-light)
}

.move_money .tabSelector .active:last-child {
    background-color: var(--error-light-hover)
}

.ps__rail-y {
    z-index: 150
}

/******** trade ticket custome styles ***********/
.trade-ticket hr {
    margin: 0.5rem 0;
    color: inherit;
    border: 0;
    border-top: 1px dashed #a1a1a1 !important;
    opacity: 1 !important;
}

.trade-ticket label:first-child {
    background: #e6f2fa;
    padding: 1px 0.5rem;
    border-radius: 0.4rem;
}

.trade-ticket .row .col:nth-child(2) {
    background-image: linear-gradient(90deg, black -290%, transparent 5%);
    border-radius: 0.5rem;
}

.trade-ticket .row .col .row .col {
    border-left: none
}

/********** attach icon**********/
.custom-file-label::after {
    content: "\\f0c6";
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
    /*font-size: large;*/
    margin: 0 5px
}
/**************** link classes *******************/
.link-style {
    /*font-weight: 600;*/
    /*text-decoration: underline;*/
    cursor: pointer
}

    .link-style:hover {
        font-weight: 600;
        text-decoration: underline;
        /*color: var(--grey-normal);*/
    }


.pp-table table th {
    padding: 10px 5px;
    border-bottom: 1px solid #0000001a
}

.pp-table table td {
    padding: 5px
}

    .pp-table table td:nth-child(3) {
        background: #f5d6d6;
    }

    .pp-table table td:nth-child(4) {
        background: #ffeded;
    }

    .pp-table table td:nth-child(5) {
        background: #fff3f3;
    }

    .pp-table table td:nth-child(6) {
        border-top: 1px solid #e5e5e5;
        background: #e7f5ff;
    }

    .pp-table table td:nth-child(7) {
        background: #ecffec;
    }

    .pp-table table td:nth-child(8) {
        background: #e3fbe3;
    }

    .pp-table table td:nth-child(9) {
        background: #d2efd2;
    }
    /**************/

.deposit-money-form .accordion-button {
    padding: 5px;
    font-size:0.8rem
}

.quote-sticky-header {
    align-items: center;
    background-color: #fff;
    border-bottom: 1px solid #ebebeb;
    column-gap: 16px;
    display: flex;
    height: 64px;
    /*margin-top: -65px;*/
    padding-left: var(--adaptive-mf-container-padding);
    padding-right: var(--adaptive-mf-container-padding);
    position: sticky;
    top: 64px;
    transform: translateY(-65px);
    transition: transform .1s ease-in-out;
    z-index: 98;
}

.quote-research p {
    font-size: 12px !important;
    font-weight: 700
}

.price-click-style:hover {
    /*border: 1px solid #CC0000;*/
    text-decoration:underline;
    cursor: pointer;
    font-weight: 700;
   
}

.balance-card {
    flex: 1;
    padding: 20px;
    border-radius: 8px;
    text-align: center;
    box-sizing: border-box;
    min-width: 0;
}
    .balance-card.from {
        border-color: #ff9800 !important;
        border: 3px solid;
        background: #fff8e1;
    }
    .balance-card.to {
        border-color: !important;
        border: 3px solid #4caf50;
        background: #e8f5e9;
    }

/* warn message div */
.warn-message-div {
    justify-content: center;
    background-color: rgb(255, 215, 185);
    opacity: 1;
    border-width: 2px;
    border-style: dashed;
    border-color: rgb(226, 94, 62);
    border-radius: 8px;
    padding: 10px;
    margin-top: 5px;
    color: rgb(51, 51, 51);
    clear: both;
}
.validation-msg {
    margin-top: 8px;
    padding: 10px;
    border-radius: 4px;
    font-size: 14px;
}

.validation-msg.error {
    background: #ffebee;
    color: #c62828;
    border: 1px solid #ef5350;
}
/* Price change animation */
@keyframes priceFlash {
    0% {
        background-color: transparent;
        transform: scale(1);
    }

    50% {
        background-color: #ffd7b9;
        transform: scale(1.02);
    }

    100% {
        background-color: transparent;
        transform: scale(1);
    }
}

.price-changed {
    animation: priceFlash 0.6s ease-in-out;
}

/* Alternative: Glow effect */
@keyframes priceGlow {
    0% {
        box-shadow: 0 0 0px transparent;
    }

    50% {
        box-shadow: 0 0 15px rgba(0, 121, 194, 0.6);
    }

    100% {
        box-shadow: 0 0 0px transparent;
    }
}

.price-changed-glow {
    animation: priceGlow 0.8s ease-in-out;
}

@media (min-width: 576px) {
    .small-modal .modal-dialog {
        max-width: 30vw !important;
    }

    .medium-modal .modal-dialog {
        max-width: 55vw !important;
    }

    .large-modal .modal-dialog {
        max-width: 75vw !important;
    }
}

`, "",{"version":3,"sources":["webpack://./client/assets/style/website.css"],"names":[],"mappings":"AAAA,SAAS;;AAGT;IACI,4BAA4B;AAChC;;AAEA,SAAS;AACT;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,+BAA+B;IAC/B,+BAA+B;IAC/B,yBAAyB;IACzB,+BAA+B;IAC/B,gCAAgC;IAChC,uBAAuB;IACvB,6BAA6B;IAC7B,8BAA8B;IAC9B,yBAAyB;IACzB,SAAS;IACT,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;IAC5B,sBAAsB;IACtB,4BAA4B;IAC5B,6BAA6B;IAC7B,oBAAoB;IACpB,0BAA0B;IAC1B,2BAA2B;IAC3B,sBAAsB;IACtB,UAAU;IACV,sBAAsB;IACtB,4BAA4B;IAC5B,6BAA6B;IAC7B,uBAAuB;IACvB,6BAA6B;IAC7B,8BAA8B;IAC9B,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;IAC5B,uBAAuB;IACvB,eAAe;IACf,2BAA2B;IAC3B,iCAAiC;IACjC,kCAAkC;IAClC,4BAA4B;IAC5B,kCAAkC;IAClC,mCAAmC;IACnC,0BAA0B;IAC1B,gCAAgC;IAChC,iCAAiC;IACjC,4BAA4B;IAC5B,UAAU;IACV,sBAAsB;IACtB,4BAA4B;IAC5B,6BAA6B;IAC7B,uBAAuB;IACvB,6BAA6B;IAC7B,8BAA8B;IAC9B,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;IAC5B,uBAAuB;IACvB,UAAU;IACV,sBAAsB;IACtB,4BAA4B;IAC5B,6BAA6B;IAC7B,uBAAuB;IACvB,6BAA6B;IAC7B,8BAA8B;IAC9B,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;IAC5B,uBAAuB;IACvB,yBAAyB;IACzB,WAAW;IACX,yCAAyC;IACzC,sCAAsC;IACtC,oBAAoB;IACpB,uBAAuB,EAAE,wBAAwB;IACjD;AACJ;;AAEA;IACI,mCAAmC;IACnC,6CAA6C;IAC7C,+CAA+C;IAC/C,0DAA0D;IAC1D,iDAAiD;IACjD,2DAA2D;IAC3D,4CAA4C;IAC5C,sDAAsD;AAC1D;;AAEA;IACI,gCAAgC;IAChC,0CAA0C;IAC1C,4CAA4C;IAC5C,uDAAuD;IACvD,8CAA8C;IAC9C,wDAAwD;IACxD,yCAAyC;IACzC,mDAAmD;AACvD;;AAEA;IACI,2CAA2C;IAC3C,qCAAqC;IACrC,gDAAgD;IAChD,iCAAiC;IACjC,oCAAoC;IACpC,sCAAsC;IACtC,wDAAwD;IACxD,8CAA8C;IAC9C,wDAAwD;IACxD;AACJ;;;AAGA;IACI,mCAAmC;IACnC,sCAAsC;IACtC,qBAAqB;IACrB,wBAAwB;IACxB;AACJ;;AAEA;IACI,mCAAmC;IACnC,sCAAsC;IACtC,qBAAqB;IACrB,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI;AACJ;;AAEA;IACI,4BAA4B;IAC5B,+CAA+C;IAC/C,wDAAwD;AAC5D;AACA,mBAAmB;AACnB;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,SAAS;AACb;;AAEA;;;;;;IAMI,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;AACJ;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;IACnB;AACJ;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;IAClC,+BAA+B;AACnC;;AAEA;IACI,gCAAgC;IAChC;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,2DAA2D;IAC3D,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,WAAW;IACX,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,eAAe;IACf,sCAAsC;IACtC,kBAAkB;AACtB;;IAEI;QACI,yBAAyB;IAC7B;;;AAGJ;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB;AACJ;;IAEI;QACI,aAAa;QACb,sBAAsB;QACtB,iBAAiB;QACjB,uBAAuB;QACvB,mBAAmB;QACnB,YAAY;IAChB;;QAEI;YACI,6DAA6D;QACjE;;QAEA;YACI,gBAAgB;YAChB;QACJ;;;AAGR;IACI;AACJ;;AAEA;;;EAGE;;AAEF,6DAA6D;AAC7D;;;EAGE;;AAEF;IACI,qBAAqB;IACrB,gCAAgC;IAChC,wBAAwB;AAC5B;AACA,mFAAmF;AACnF;;;CAGC;AACD;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,2CAA2C;IAC3C,YAAY;IACZ,UAAU;AACd;;;AAGA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,wBAAwB;AAC5B;;;IAGI;QACI,gBAAgB;QAChB,WAAW;IACf;;IAEA;;QAEI,qBAAqB;IACzB;;AAEJ;IACI,qBAAqB;IACrB,WAAW;AACf;;;IAGI;QACI,aAAa;IACjB;;AAEJ;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf;AACJ;;;IAGI;QACI,gBAAgB;QAChB,UAAU;QACV,gBAAgB;QAChB,8BAA8B;QAC9B,gFAAgF;QAChF,mBAAmB;QACnB,wCAAwC;IAC5C;;;;;IAKA;QACI,uFAAuF;QACvF,gBAAgB;QAChB,uBAAuB;IAC3B;;QAEI;YACI,0BAA0B;YAC1B,gBAAgB;YAChB,iBAAiB;YACjB,yBAAyB;QAC7B;;;QAGA;YACI,eAAe;YACf,gBAAgB;YAChB,WAAW;QACf;;QAEA;YACI,8BAA8B;YAC9B,4BAA4B;QAChC;;QAEA;YACI,+BAA+B;YAC/B,6BAA6B;QACjC;;IAEJ;QACI,+BAA+B;QAC/B,6BAA6B;IACjC;;IAEA;;MAEE;;IAEF;QACI;IACJ;;;IAGA;QACI,yBAAyB;QACzB,8BAA8B;IAClC;;QAEI;YACI,+BAA+B;YAC/B,6BAA6B;QACjC;;QAEA;YACI,8BAA8B;YAC9B,4BAA4B;YAC5B,6BAA6B;YAC7B,2BAA2B;QAC/B;;QAEA;YACI;QACJ;;IAEJ;QACI,YAAY;QACZ,YAAY;IAChB;;AAEJ;IACI,oBAAoB;IACpB,qBAAqB;IACrB,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,oBAAoB;;AAEpB;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,4BAA4B;AAChC;;AAEA,oDAAoD;AACpD;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;;AAGA,qCAAqC;;AAErC;;IAEI;+CAC2C;IAC3C,YAAY;IACZ;AACJ;;AAEA;IACI,uDAAuD;AAC3D;AACA,gCAAgC;AAChC;IACI,8BAA8B;IAC9B,qCAAqC;IACrC,iCAAiC;IACjC,gDAAgD;IAChD,mBAAmB;IACnB,uBAAuB;IACvB,0BAA0B;AAC9B;;IAEI;QACI,sCAAsC;QACtC,yCAAyC;QACzC,6CAA6C;QAC7C,iDAAiD;IACrD;;IAEA;QACI,sCAAsC;QACtC,iDAAiD;QACjD,6CAA6C;QAC7C,iDAAiD;IACrD;;AAEJ;IACI,mCAAmC;IACnC,0BAA0B;AAC9B;;IAEI;QACI,6CAA6C;QAC7C,0CAA0C;IAC9C;;AAEJ;IACI,sCAAsC;AAC1C;;IAEI;QACI,yCAAyC;QACzC;IACJ;;IAEA;QACI,6CAA6C;IACjD;;AAEJ;IACI,mBAAmB;IACnB,aAAa;IACb,SAAS;IACT,qCAAqC;AACzC;;AAEA;IACI;AACJ;;IAEI;QACI,sCAAsC;IAC1C;;AAEJ;IACI,8CAA8C;IAC9C,0BAA0B;IAC1B;AACJ;AACA,aAAa;AACb;;IAEI,0CAA0C;AAC9C;;AAEA;IACI;AACJ;AACA;IACI,iDAAiD;IACjD,6CAA6C;IAC7C,iDAAiD;AACrD;AACA;IACI;AACJ;IACI,mCAAmC;IACnC;IACA,gDAAgD;IAChD,iDAAiD;AACrD;;AAEA;;;IAGI,8BAA8B;IAC9B,qCAAqC;IACrC,qCAAqC;AACzC;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA,8BAA8B;AAC9B,2DAA2D;AAC3D;;;;;;4BAM4B;AAC5B,kDAAkD;AAClD;EACE;;AAEF;AACA;;IAEI;;;QAGI,qBAAqB;IACzB;;AAEJ;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA,mBAAmB;AACnB;IACI,gBAAgB;IAChB,oBAAoB;IACpB,4BAA4B;IAC5B,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,4BAA4B;IAC5B,qBAAqB;AACzB;;AAEA;;;IAGI,aAAa;AACjB;;AAEA,6BAA6B;AAC7B;AACA;;AAEA,6BAA6B;AAC7B;IACI,uCAAuC;IACvC,mCAAmC;AACvC;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB;AACJ;;AAEA,0BAA0B;;AAE1B;IACI,0CAA0C;IAC1C,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB,2BAA2B;IAC3B;AACJ;;AAEA;IACI,2CAA2C;IAC3C,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB,2BAA2B;IAC3B;AACJ;;AAEA;IACI,uFAAuF;AAC3F;;AAEA;IACI,wFAAwF;AAC5F;;AAEA;IACI,mCAAmC;IACnC,gDAAgD;IAChD,mBAAmB;IACnB,sBAAsB;IACtB,gCAAgC;IAChC,sBAAsB;IACtB,iBAAiB;IACjB;AACJ;;AAEA;IACI,oCAAoC;IACpC,iDAAiD;IACjD,mBAAmB;IACnB,sBAAsB;IACtB,gCAAgC;IAChC,sBAAsB;IACtB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,0CAA0C;IAC1C,0BAA0B;IAC1B,iBAAiB;IACjB;AACJ;;AAEA;IACI,2CAA2C;IAC3C,0BAA0B;IAC1B,iBAAiB;IACjB;AACJ;AACA,oCAAoC;;AAEpC;IACI,kDAAkD;IAClD,0BAA0B;AAC9B;;AAEA,8BAA8B;AAC9B;IACI;AACJ;;AAEA;IACI,oBAAoB;AACxB;;IAEI;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;AAEJ;IACI,YAAY;AAChB;;AAEA,oCAAoC;AACpC;IACI,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA,+DAA+D;AAC/D;IACI,aAAa;IACb,mBAAmB;IACnB,gCAAgC;IAChC,yBAAyB;IACzB,oBAAoB;IACpB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;;AAGA;IACI,6BAA6B;AACjC;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,YAAY;AAChB;;AAEA;IACI;QACI,2CAA2C;IAC/C;;IAEA;QACI,4CAA4C;IAChD;;IAEA;QACI,yCAAyC;IAC7C;AACJ;;AAEA;IACI,6DAA6D;IAC7D,gCAAgC;IAChC,oCAAoC;IACpC;AACJ;;;AAGA;IACI,oBAAoB;AACxB;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA,iDAAiD;AACjD;IACI,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,yCAAyC;IACzC,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,qEAAqE;IACrE,qBAAqB;AACzB;;AAEA;IACI;AACJ;;AAEA,iCAAiC;AACjC;IACI,gBAAgB;IAChB,kCAAkC;IAClC,gBAAgB;IAChB,oBAAoB;IACpB;AACJ;AACA,kDAAkD;AAClD;IACI,oBAAoB;IACpB,8BAA8B;IAC9B;AACJ;;IAEI;QACI,gBAAgB;QAChB,0BAA0B;QAC1B,6BAA6B;IACjC;;;AAGJ;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;IAEI;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,6BAA6B;QAC7B,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;IACA,eAAe;;AAEnB;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,gCAAgC;IAChC,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,qBAAqB;IACrB,kDAAkD;IAClD,mDAAmD;IACnD,gBAAgB;IAChB,SAAS;IACT,4BAA4B;IAC5B,qCAAqC;IACrC,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,eAAe;IACf,gBAAgB;;AAEpB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;AAChB;IACI;QACI,gCAAgC;QAChC,iBAAiB;QACjB,mBAAmB;IACvB;IACA;QACI,wBAAwB;QACxB,yBAAyB;QACzB,mBAAmB;IACvB;;AAEJ,qBAAqB;AACrB;IACI,uBAAuB;IACvB,oCAAoC;IACpC,UAAU;IACV,iBAAiB;IACjB,oBAAoB;IACpB,8BAA8B;IAC9B,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,WAAW;AACf;AACA;IACI,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;AACA,2BAA2B;AAC3B;IACI;QACI,6BAA6B;QAC7B,mBAAmB;IACvB;;IAEA;QACI,yBAAyB;QACzB,sBAAsB;IAC1B;;IAEA;QACI,6BAA6B;QAC7B,mBAAmB;IACvB;AACJ;;AAEA;IACI,sCAAsC;AAC1C;;AAEA,6BAA6B;AAC7B;IACI;QACI,+BAA+B;IACnC;;IAEA;QACI,2CAA2C;IAC/C;;IAEA;QACI,+BAA+B;IACnC;AACJ;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":["/* Font */\r\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap\");\r\n\r\nbody {\r\n    font-family: \"Inter\", Tahoma;\r\n}\r\n\r\n/* Root */\r\n:root {\r\n    --primary-light: #e6f2fa;\r\n    --primary-light-hover: #d9ebf7;\r\n    --primary-light-active: #b1d5ee;\r\n    --primary-normal-light: #02a6e5;\r\n    --primary-normal: #0378c9;\r\n    --primary-normal-hover: #036cb5;\r\n    --primary-normal-active: #0260a1;\r\n    --primary-dark: #025a97;\r\n    --primary-dark-hover: #024879;\r\n    --primary-dark-active: #01365a;\r\n    --primary-darker: #012a46;\r\n    /* Grey */\r\n    --grey-light: #f2f2f2;\r\n    --grey-light-hover: #ececec;\r\n    --grey-light-active: #d8d8d8;\r\n    --grey-normal: #808080;\r\n    --grey-normal-hover: #737373;\r\n    --grey-normal-active: #666666;\r\n    --grey-dark: #606060;\r\n    --grey-dark-hover: #4d4d4d;\r\n    --grey-dark-active: #3a3a3a;\r\n    --grey-darker: #2d2d2d;\r\n    /* Error */\r\n    --error-light: #fbe7e7;\r\n    --error-light-hover: #f9dbdb;\r\n    --error-light-active: #f3b5b5;\r\n    --error-normal: #d80f0f;\r\n    --error-normal-hover: #c20e0e;\r\n    --error-normal-active: #ad0c0c;\r\n    --error-dark: #a20b0b;\r\n    --error-dark-hover: #820909;\r\n    --error-dark-active: #610707;\r\n    --error-darker: #4c0505;\r\n    /* successful */\r\n    --successful-light: #e7feec;\r\n    --successful-light-hover: #dbfde3;\r\n    --successful-light-active: #b5fac4;\r\n    --successful-normal: #10f041;\r\n    --successful-normal-hover: #0ed83b;\r\n    --successful-normal-active: #0dc034;\r\n    --successful-dark: #009f22;\r\n    --successful-dark-hover: #0a9027;\r\n    --successful-dark-active: #076c1d;\r\n    --successful-darker: #065417;\r\n    /* White */\r\n    --white-light: #ffffff;\r\n    --white-light-hover: #ffffff;\r\n    --white-light-active: #ffffff;\r\n    --white-normal: #ffffff;\r\n    --white-normal-hover: #e6e6e6;\r\n    --white-normal-active: #cccccc;\r\n    --white-dark: #bfbfbf;\r\n    --white-dark-hover: #999999;\r\n    --white-dark-active: #737373;\r\n    --white-darker: #595959;\r\n    /* Black */\r\n    --black-light: #e6e6e6;\r\n    --black-light-hover: #d9d9d9;\r\n    --black-light-active: #b0b0b0;\r\n    --black-normal: #000000;\r\n    --black-normal-hover: #000000;\r\n    --black-normal-active: #000000;\r\n    --black-dark: #000000;\r\n    --black-dark-hover: #000000;\r\n    --black-dark-active: #000000;\r\n    --black-darker: #000000;\r\n    --black-border: #00000010;\r\n    /* Shadow */\r\n    --shadow-large: 0px 4px 4px 0px #0000001a;\r\n    --shadow-2: 0px 0px 30px 0px #0000000d;\r\n    /* buy sell colors */\r\n    --buy-bg-color: #c9e9ff; /*var(--primary-light);*/\r\n    --sell-bg-color: #FFCCCC /*var(--error-light-hover);*/\r\n}\r\n\r\n.btn-primary {\r\n    --bs-btn-bg: var( --primary-normal);\r\n    --bs-btn-border-color: var( --primary-normal);\r\n    --bs-btn-hover-bg: var( --primary-normal-hover);\r\n    --bs-btn-hover-border-color: var( --primary-normal-active);\r\n    --bs-btn-active-bg: var( --primary-normal-active);\r\n    --bs-btn-active-border-color: var( --primary-normal-active);\r\n    --bs-btn-disabled-bg: var( --primary-normal);\r\n    --bs-btn-disabled-border-color: var( --primary-normal);\r\n}\r\n\r\n.btn-secondary {\r\n    --bs-btn-bg: var( --grey-normal);\r\n    --bs-btn-border-color: var( --grey-normal);\r\n    --bs-btn-hover-bg: var( --grey-normal-hover);\r\n    --bs-btn-hover-border-color: var( --grey-normal-active);\r\n    --bs-btn-active-bg: var( --grey-normal-active);\r\n    --bs-btn-active-border-color: var( --grey-normal-active);\r\n    --bs-btn-disabled-bg: var( --grey-normal);\r\n    --bs-btn-disabled-border-color: var( --grey-normal);\r\n}\r\n\r\n.list-group {\r\n    --bs-list-group-color: var(--bs-body-color);\r\n    --bs-list-group-bg: var(--bs-body-bg);\r\n    --bs-list-group-border-color: var(--grey-normal);\r\n    --bs-list-group-border-width: 1px;\r\n    --bs-list-group-item-padding-x: 1rem;\r\n    --bs-list-group-item-padding-y: 0.5rem;\r\n    --bs-list-group-active-color: var(--black-normal-active);\r\n    --bs-list-group-active-bg: var(--white-normal);\r\n    --bs-list-group-active-border-color: var(--white-normal);\r\n    min-height: 45px\r\n}\r\n\r\n\r\n.list-group-item.active {\r\n    border-top-color: var(--grey-light);\r\n    border-bottom-color: var(--grey-light);\r\n    border-top-width: 1px;\r\n    border-bottom-width: 1px;\r\n    vertical-align: middle\r\n}\r\n\r\n.list-group-item {\r\n    border-top-color: var(--grey-light);\r\n    border-bottom-color: var(--grey-light);\r\n    border-top-width: 1px;\r\n    border-bottom-width: 1px;\r\n    border-right-width: 0px;\r\n    border-left-width: 0px;\r\n}\r\n\r\n.list-group-item {\r\n    padding: 0.7rem 0 !important;\r\n}\r\n\r\n.order-summary .list-group {\r\n    min-height: auto !important\r\n}\r\n\r\n.order-summary .list-group-item {\r\n    padding: 0.4rem 0 !important;\r\n    border-top-color: var(--grey-normal) !important;\r\n    border-bottom-color: var(--grey-light-active) !important;\r\n}\r\n/* Reset Elements */\r\nul {\r\n    list-style: none;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\na {\r\n    text-decoration: none;\r\n    color: #000;\r\n}\r\n\r\nbutton {\r\n    background-color: transparent;\r\n    border: none;\r\n    padding: 0;\r\n}\r\n\r\np {\r\n    margin: 0;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6 {\r\n    margin: 0;\r\n}\r\n\r\ntable tr:last-child td {\r\n    border-bottom: none;\r\n}\r\n\r\ntable thead td {\r\n    font-weight:bold\r\n}\r\n\r\n.table-hover > tbody > tr:hover > * {\r\n    --bs-table-bg-state: var(--primary-light) !important;\r\n}\r\n\r\n#portfolio-card #distribution-detail > div:not(:last-child), table tr:not(:last-child) td {\r\n    border-bottom: 1px solid #0000001a;\r\n}\r\n\r\n.rdp-month_grid tr td {\r\n    border-bottom: 0 !important;\r\n}\r\n\r\n.rounded-table {\r\n    border-collapse: separate;\r\n    border-spacing: 0;\r\n    border-radius: 20px;\r\n    -moz-border-radius: 5px;\r\n    border-width: 1px;\r\n    border-style: solid;\r\n    padding: 10px\r\n}\r\n\r\n.card {\r\n    border-color: #00000020 !important;\r\n}\r\n\r\n#right .card {\r\n    border-color: #00000009 !important;\r\n    box-shadow: var(--shadow-large);\r\n}\r\n\r\n#right .sigmago-links-card {\r\n    border-color: #6a6a6a !important;\r\n    background-color: #787878 !important\r\n}\r\n\r\n.container-clip {\r\n    padding: 20px;\r\n    background-color: #fff;\r\n    border-radius: 10px;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\nh1-clip {\r\n    text-align: center;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.step-con {\r\n    display: flex;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n    margin-bottom: -0.5rem;\r\n}\r\n\r\n.step {\r\n    background-color: #f5f5f5;\r\n    border-radius: 15px;\r\n    padding: 20px;\r\n    width: 100%;\r\n    font-weight: 600;\r\n}\r\n\r\n.step-number {\r\n    font-size: 70px;\r\n    font-weight: bold;\r\n    margin-right: -10px;\r\n    color: #333;\r\n    background-image: linear-gradient(to right, black, #ffffff);\r\n    color: transparent;\r\n    background-clip: text;\r\n    position: relative;\r\n}\r\n\r\n.step .description {\r\n    font-size: 16px;\r\n    line-height: 1.5;\r\n    color: #333;\r\n}\r\n\r\n.button {\r\n    display: block;\r\n    width: 100%;\r\n    padding: 15px;\r\n    border: none;\r\n    border-radius: 15px;\r\n    background-color: #007bff;\r\n    color: #fff;\r\n    font-size: 18px;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease;\r\n    margin-top: 0.5rem;\r\n}\r\n\r\n    .button:hover {\r\n        background-color: #0069d9;\r\n    }\r\n\r\n\r\n.popover-contained-header {\r\n    max-width: none !important;\r\n    width: 400px\r\n}\r\n\r\n.bs-popover-bottom .arrow::after, .bs-popover-auto[x-placement^=\"bottom\"] .arrow::after {\r\n    border-bottom-color: #007bff !important;\r\n}\r\n\r\n.popover-contained-header .col-icon {\r\n    padding: 0 !important;\r\n    min-width: 105px;\r\n    height: 60px;\r\n    border: 1px solid #656565;\r\n    text-align: center;\r\n    vertical-align: middle\r\n}\r\n\r\n    .popover-contained-header .col-icon a {\r\n        display: flex;\r\n        flex-direction: column;\r\n        flex-wrap: nowrap;\r\n        justify-content: center;\r\n        align-items: center;\r\n        height: 60px;\r\n    }\r\n\r\n        .popover-contained-header .col-icon a:hover {\r\n            background: repeating-radial-gradient(#3a3a3a, #6d6d6d 100px);\r\n        }\r\n\r\n        .popover-contained-header .col-icon a:active {\r\n            background: #ccc;\r\n            color: #3a3a3a\r\n        }\r\n\r\n\r\n.popover-contained-header .fa-2x {\r\n    font-size: 1.7em !important\r\n}\r\n\r\n/*.order-modal-container {\r\n    position: relative;\r\n    height: 100%\r\n}*/\r\n\r\n/* positions the grey background relative to the parent div */\r\n/*.custome-modal-backdrop {\r\n    position: absolute !important;\r\n    width: 100% !important;\r\n}*/\r\n\r\n.custome-modal-backdrop.show {\r\n    opacity: 1 !important;\r\n    background: #b5b5b536 !important;\r\n    /* border-radius: 15px;*/\r\n}\r\n/* positions the modal within the parent div, but in front of the grey background */\r\n/*.order-modal-container .modal {\r\n    position: absolute;\r\n}\r\n*/\r\n.create-alert .w-50 {\r\n    width: 49% !important\r\n}\r\n\r\n.create-alert .forc-w-100 .w-50 {\r\n    width: 99% !important\r\n}\r\n\r\n.react-tags {\r\n    position: relative;\r\n    line-height: 2;\r\n    /* clicking anywhere will focus the input */\r\n    cursor: text;\r\n    z-index: 9;\r\n}\r\n\r\n\r\n.react-tags__selected {\r\n    display: inline;\r\n}\r\n\r\n.react-tags__selected-tag {\r\n    display: inline-block;\r\n    box-sizing: border-box;\r\n    border: 1px solid #D1D1D1;\r\n    background: #F1F1F1;\r\n    line-height: 1.2;\r\n    /* match the font styles */\r\n    font-size: inherit;\r\n    height: 26px;\r\n    margin: 0.2rem 0 0 0.2rem;\r\n    position: absolute;\r\n    z-index: 10;\r\n    padding: 2px;\r\n    border-radius: 10px\r\n    /*line-height: inherit;*/\r\n}\r\n\r\n\r\n    .react-tags__selected-tag:after {\r\n        content: '\\2715';\r\n        color: #AAA;\r\n    }\r\n\r\n    .react-tags__selected-tag:hover,\r\n    .react-tags__selected-tag:focus {\r\n        border-color: #B1B1B1;\r\n    }\r\n\r\n.react-tags__search {\r\n    display: inline-block;\r\n    width: 100%;\r\n}\r\n\r\n\r\n    .react-tags__search input::-ms-clear {\r\n        display: none;\r\n    }\r\n\r\n.react-tags__suggestions {\r\n    position: absolute;\r\n    top: 100%;\r\n    left: 0;\r\n    width: 100%;\r\n    min-width: 300px;\r\n    font-size: 12px;\r\n    margin-top: -1px\r\n}\r\n\r\n\r\n    .react-tags__suggestions ul {\r\n        margin: 4px -1px;\r\n        padding: 0;\r\n        list-style: none;\r\n        background: var(--white-light);\r\n        border: 1px solid var(--ag-header-column-separator-color, rgba(66, 66, 66, 0.5));\r\n        border-radius: 20px;\r\n        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n\r\n\r\n\r\n    .react-tags__suggestions li {\r\n        border-bottom: 1px solid var(--ag-header-column-separator-color, rgba(66, 66, 66, 0.2));\r\n        padding: 6px 8px;\r\n        color: var(--grey-dark);\r\n    }\r\n\r\n        .react-tags__suggestions li mark {\r\n            text-decoration: underline;\r\n            background: none;\r\n            font-weight: bold;\r\n            color: var(--grey-darker);\r\n        }\r\n\r\n\r\n        .react-tags__suggestions li:hover {\r\n            cursor: pointer;\r\n            background: #eee;\r\n            color: #333;\r\n        }\r\n\r\n        .react-tags__suggestions li:last-child:hover {\r\n            border-start-start-radius: 0px;\r\n            border-start-end-radius: 0px;\r\n        }\r\n\r\n        .react-tags__suggestions li:first-child:hover {\r\n            border-start-start-radius: 20px;\r\n            border-start-end-radius: 20px;\r\n        }\r\n\r\n    .react-tags__suggestions ul:nth-child(0):hover {\r\n        border-start-start-radius: 20px;\r\n        border-start-end-radius: 20px;\r\n    }\r\n\r\n    /*.react-tags__suggestions #ReactTags-listbox-0 {\r\n        border-radius: 20px;\r\n    }*/\r\n\r\n    .react-tags__suggestions li:hover mark {\r\n        color: #333\r\n    }\r\n\r\n\r\n    .react-tags__suggestions li.is-active {\r\n        color: var(--white-light);\r\n        background: var(--grey-darker);\r\n    }\r\n\r\n        .react-tags__suggestions li.is-active:first-child {\r\n            border-start-start-radius: 20px;\r\n            border-start-end-radius: 20px;\r\n        }\r\n\r\n        .react-tags__suggestions li.is-active:last-child {\r\n            border-start-start-radius: 0px;\r\n            border-start-end-radius: 0px;\r\n            border-end-start-radius: 20px;\r\n            border-end-end-radius: 20px;\r\n        }\r\n\r\n        .react-tags__suggestions li.is-active mark {\r\n            color: var(--primary-light-active)\r\n        }\r\n\r\n    .react-tags__suggestions li.is-disabled {\r\n        opacity: 0.5;\r\n        cursor: auto;\r\n    }\r\n\r\n.header-search .react-tags__search-input input {\r\n    border: 0 !important;\r\n    width: 90% !important;\r\n    padding: 0;\r\n    margin: 0\r\n}\r\n\r\n.header-search .react-tags__search-input .form-control:focus {\r\n    box-shadow: none !important\r\n}\r\n\r\n.header-search .quoteListOptionsContainer .input-group-append {\r\n    display: none\r\n}\r\n\r\n.header-search .react-tags__selected-tag-name {\r\n    font-size: 13px;\r\n    padding: 2px\r\n}\r\n\r\n.react-tags__suggestions li:last-child {\r\n    border-bottom: 0;\r\n    border-radius: 20px;\r\n}\r\n\r\n/**** font sizes ***/\r\n\r\n.font-size-large {\r\n    font-size: large\r\n}\r\n\r\n.font-size-xlarge {\r\n    font-size: x-large\r\n}\r\n\r\n.font-size-small {\r\n    font-size: 11px\r\n}\r\n\r\n.font-size-xsmall {\r\n    font-size: x-small\r\n}\r\n\r\n.font-size-xxsmall {\r\n    font-size: xx-small\r\n}\r\n\r\n.fs-3 {\r\n    font-size: 1.5rem !important;\r\n}\r\n\r\n/**************** border rounds ********************/\r\n.border-r10 {\r\n    border-radius: 10px;\r\n}\r\n\r\n.border-r20 {\r\n    border-radius: 20px;\r\n}\r\n\r\n.border-r15 {\r\n    border-radius: 15px;\r\n}\r\n\r\n.border-r25 {\r\n    border-radius: 25px;\r\n}\r\n\r\n.border-r40 {\r\n    border-radius: 40px;\r\n}\r\n\r\n\r\n/*********** dropdown ***************/\r\n\r\n.dropdown .btn, .dropdown .btn-check:checked + .btn, .dropdown .btn.active, .btn.show,\r\n.dropdown .btn:first-child:active, .dropdown :not(.btn-check) + .btn:active {\r\n    /* color: var(--bs-btn-active-color);\r\n    background-color: var(--bs-btn-active-bg);*/\r\n    border: none;\r\n    border-width: 0px !important\r\n}\r\n\r\n.dropdown .dropdown-menu {\r\n    --bs-dropdown-link-active-bg: var(--grey-normal-active);\r\n}\r\n/********* buttons style *******/\r\n.secondary-pills-nav .nav-link, .secondary-pills-nav .btn {\r\n    border-radius: 10px !important;\r\n    color: var(--black-normal) !important;\r\n    padding: 0.2rem 0.8rem !important;\r\n    border: 1px solid var(--black-border) !important;\r\n    margin: auto 0.2rem;\r\n    height: auto !important;\r\n    min-width: auto !important;\r\n}\r\n\r\n    .secondary-pills-nav .nav-link:hover, .secondary-pills-nav .btn-outline-secondary:hover {\r\n        border: 1px solid var(--primary-light);\r\n        background-color: var(--grey-light-hover);\r\n        color: var(--primary-normal-hover) !important;\r\n        border: 1px solid var(--primary-light) !important;\r\n    }\r\n\r\n    .secondary-pills-nav .nav-link.active, .secondary-pills-nav .btn-primary {\r\n        border: 1px solid var(--primary-light);\r\n        background-color: var(--primary-light) !important;\r\n        color: var(--primary-normal-light) !important;\r\n        border: 1px solid var(--primary-light) !important;\r\n    }\r\n\r\n.btn-outline-primary {\r\n    border-color: var(--primary-normal);\r\n    color: var(--black-normal);\r\n}\r\n\r\n    .btn-outline-primary:hover {\r\n        background-color: var(--primary-normal-hover);\r\n        border-color: var(--primary-normal-hover );\r\n    }\r\n\r\n.action-icon-btn {\r\n    background-color: var(--primary-light);\r\n}\r\n\r\n    .action-icon-btn:hover {\r\n        background-color: var(--grey-light-hover);\r\n        color: var(--primary-normal-hover)\r\n    }\r\n\r\n    .action-icon-btn:active {\r\n        background-color: var(--primary-light-active);\r\n    }\r\n\r\n.primary-custome-nav .nav-link {\r\n    border-radius: 1rem;\r\n    padding: 1rem;\r\n    border: 0;\r\n    color: var(--black-normal) !important;\r\n}\r\n\r\n.primary-custome-nav .nav-link {\r\n    height: auto !important\r\n}\r\n\r\n    .primary-custome-nav .nav-link.active {\r\n        background-color: var(--primary-light);\r\n    }\r\n\r\n.bg-primary {\r\n    background-color: var(--grey-light) !important;\r\n    color: var(--black-normal);\r\n    font-weight: 600\r\n}\r\n/*.btn.show,*/\r\n.btn-check:checked + .btn, .btn.active, .btn:first-child:active,\r\n:not(.btn-check) + .btn:active {\r\n    background-color: var(--grey-light-active);\r\n}\r\n\r\n.btn.disabled, .btn:disabled, fieldset:disabled .btn {\r\n    opacity: 0.20 !important\r\n}\r\n.dropdown-item.active, .dropdown-item:active {\r\n    background-color: var(--primary-light) !important;\r\n    color: var(--primary-normal-light) !important;\r\n    border: 1px solid var(--primary-light) !important;\r\n}\r\n.navbar-brand .dropdown-item.active, .navbar-brand .dropdown-item:active {\r\n    border:0 !important\r\n}\r\n    /************** AG_GRID************/\r\n    .ag-theme-balham .ag-header {\r\n    background-color: var(--white-normal) !important;\r\n    border-bottom-color: var(--white-dark) !important;\r\n}\r\n\r\n.ag-theme-balham .ag-filter-toolpanel-header, .ag-theme-balham .ag-filter-toolpanel-search,\r\n.ag-theme-balham .ag-status-bar, .ag-theme-balham .ag-header-row,\r\n.ag-theme-balham .ag-multi-filter-group-title-bar {\r\n    font-weight: normal !important;\r\n    color: rgba(0, 0, 0, 0.90) !important;\r\n    color: var(--black-normal) !important;\r\n}\r\n\r\n.ag-theme-balham .ag-row-odd {\r\n    background-color: var(--white-light) !important\r\n}\r\n\r\n.ag-theme-balham .ag-row {\r\n    border: 1px\r\n}\r\n\r\n.ag-theme-balham .ag-cell {\r\n    border: none !important\r\n}\r\n\r\n/*.ag-theme-balham .ag-cell {*/\r\n/* border-right: 1px solid rgb(203, 206, 217) !important; */\r\n/*}\r\n\r\n.ag-theme-balham-dark .ag-cell {\r\n    border-right: 1px solid #5c5c5c !important;\r\n}\r\n\r\n.ag-theme-balham .ag-cell {*/\r\n/*border-right: 1px solid #d9dcde !important;    */\r\n/*border-right: 1px solid #cbced9 !important;\r\n}*/\r\n\r\n.ag-react-container {\r\n}\r\n\r\n    .ag-react-container div,\r\n    .ag-react-container span,\r\n    .ag-cell {\r\n        align-content: center;\r\n    }\r\n\r\n.aggrid-button .btn-sm {\r\n    font-size: inherit;\r\n    padding: 3px 9px;\r\n}\r\n\r\n.aggrid-button > .btn + .btn {\r\n    margin-left: 2px;\r\n    margin-right: 2px\r\n}\r\n\r\n/* Custom Classes */\r\n.line-clamp-1 {\r\n    overflow: hidden;\r\n    display: -webkit-box;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-line-clamp: 1;\r\n}\r\n\r\n.line-clamp-2 {\r\n    overflow: hidden;\r\n    display: -webkit-box;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-line-clamp: 2;\r\n}\r\n\r\ninput[type=\"date\"]::-webkit-calendar-picker-indicator,\r\ninput[type=\"date\"]::-ms-clear,\r\ninput[type=\"date\"]::-moz-clear {\r\n    display: none;\r\n}\r\n\r\n/********* keyboard *********/\r\n.hg-theme-default {\r\n}\r\n\r\n/********* check box ********/\r\n.form-check-input:checked {\r\n    background-color: var(--primary-normal);\r\n    border-color: var(--primary-normal);\r\n}\r\n\r\n.hg-theme-default .hg-button {\r\n    height: 30px !important;\r\n    border: 1px solid;\r\n    border-color: var(--grey-normal) !important\r\n}\r\n\r\n/**** buy sell style******/\r\n\r\n.btn-buy {\r\n    background: var(--buy-bg-color) !important;\r\n    color: #000 !important;\r\n    font-weight: 600;\r\n    border-radius: 15px;\r\n    box-shadow: var(--shadow-2);\r\n    border: 0px\r\n}\r\n\r\n.btn-sell {\r\n    background: var(--sell-bg-color) !important;\r\n    color: #000 !important;\r\n    font-weight: 600;\r\n    border-radius: 15px;\r\n    box-shadow: var(--shadow-2);\r\n    border: 0px\r\n}\r\n\r\ntable .buyRow td {\r\n    background-image: linear-gradient(to bottom, var(--buy-bg-color), #c9e9ff99) !important;\r\n}\r\n\r\ntable .sellRow td {\r\n    background-image: linear-gradient(to bottom, var(--sell-bg-color), #ffcccc99) !important;\r\n}\r\n\r\n.custome-order-type-buy {\r\n    /*background: var(--buy-bg-color);*/\r\n    border: 2px solid var(--buy-bg-color) !important;\r\n    padding-top: 0.3rem;\r\n    padding-bottom: 0.3rem;\r\n    padding-left: 2.35rem !important;\r\n    border-radius: 0.45rem;\r\n    font-weight: bold;\r\n    opacity: 0.85\r\n}\r\n\r\n.custome-order-type-sell {\r\n    /*background: var(--sell-bg-color);*/\r\n    border: 2px solid var(--sell-bg-color) !important;\r\n    padding-top: 0.3rem;\r\n    padding-bottom: 0.3rem;\r\n    padding-left: 2.35rem !important;\r\n    border-radius: 0.45rem;\r\n    font-weight: bold;\r\n    opacity: 0.85;\r\n}\r\n\r\n.combo-selected .custome-order-type-buy {\r\n    background: var(--buy-bg-color) !important;\r\n    color: var(--black-normal);\r\n    font-weight: bold;\r\n    opacity: 1\r\n}\r\n\r\n.combo-selected .custome-order-type-sell {\r\n    background: var(--sell-bg-color) !important;\r\n    color: var(--black-normal);\r\n    font-weight: bold;\r\n    opacity: 1\r\n}\r\n/***********************************/\r\n\r\n.bg-primary-normal {\r\n    background-color: var(--primary-normal) !important;\r\n    color: var(--white-normal);\r\n}\r\n\r\n/* Add this to your CSS file */\r\n.fs-aggrid {\r\n    font-size: 12px !important\r\n}\r\n\r\n.ag-header-cell {\r\n    pointer-events: none;\r\n}\r\n\r\n    .ag-header-cell .ag-header-cell-resize {\r\n        pointer-events: all;\r\n    }\r\n\r\n    .ag-header-cell .ag-header-cell-label {\r\n        pointer-events: all;\r\n    }\r\n\r\nhr {\r\n    opacity: .10;\r\n}\r\n\r\n/*****  chart zoom position ********/\r\n.canvasjs-chart-toolbar {\r\n    left: 5px !important;\r\n    right: auto !important;\r\n}\r\n\r\n/******** activity & order history list grouo item ************/\r\n.row-list-for-cols {\r\n    display: flex;\r\n    flex-direction: row;\r\n    border-bottom: 1px solid #a9a9a9;\r\n    background-color: #f2f2f2;\r\n    padding: 1rem 0.5rem;\r\n    align-content: center\r\n}\r\n\r\n.acc-cols-width .list-group-item {\r\n    min-width: 5%;\r\n}\r\n\r\n.acc-cols-width .list-group .date {\r\n    min-width: 5%;\r\n    width: 10%\r\n}\r\n\r\n.acc-cols-width .list-group .acc-icon {\r\n    min-width: 39px;\r\n    width: 3%\r\n}\r\n\r\n.acc-cols-width .list-group .desc {\r\n    min-width: 20%;\r\n    width: 45%\r\n}\r\n\r\n.acc-cols-width .list-group .invoice {\r\n    min-width: 20%;\r\n    width: 15%\r\n}\r\n\r\n.acc-cols-width .list-group .amount {\r\n    min-width: 10%;\r\n    width: 15%\r\n}\r\n\r\n.acc-cols-width .list-group .balance {\r\n    min-width: 10%;\r\n    width: 15%\r\n}\r\n\r\n.oh-cols-width .list-group-item {\r\n    min-width: 10.7%;\r\n}\r\n\r\n.oh-cols-width .list-group .large-col {\r\n    min-width: 19.5%;\r\n    width: 15%;\r\n}\r\n\r\n.oh-cols-width .list-group .small-col {\r\n    min-width: 6.5%;\r\n}\r\n\r\n.oh-cols-width .list-group .acc-icon {\r\n    min-width: 39px;\r\n    width: 3%\r\n}\r\n\r\n.th-cols-width .list-group-item {\r\n    min-width: 11%;\r\n}\r\n\r\n.th-cols-width .list-group .large-col {\r\n    min-width: 19.5%;\r\n    width: 15%;\r\n}\r\n\r\n.th-cols-width .list-group .small-col {\r\n    min-width: 6.5%;\r\n}\r\n\r\n.th-cols-width .list-group .acc-icon {\r\n    min-width: 39px;\r\n    width: 3%\r\n}\r\n\r\n.th-cols-width-2 .list-group-item {\r\n    min-width: 14.2%;\r\n}\r\n\r\n.small-modal .list-group-item {\r\n    padding: 0.1rem !important;\r\n}\r\n\r\n\r\n.pf-css .dropdown {\r\n    font-size: inherit !important;\r\n}\r\n\r\n.modal-content {\r\n    font-size: 13px\r\n}\r\n\r\n.form-control-lg {\r\n    font-size: 13px !important\r\n}\r\n\r\n.custom-keyboard .hg-button.hg-standardBtn[data-skbtn=\"{space}\"] {\r\n    flex-grow: 1;\r\n}\r\n\r\n.custom-keyboard .language-button {\r\n    max-width: 80px;\r\n    min-width: 80px;\r\n    flex-grow: 0;\r\n}\r\n\r\n@keyframes pulse {\r\n    0% {\r\n        box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.7);\r\n    }\r\n\r\n    50% {\r\n        box-shadow: 0 0 0 10px rgba(59, 130, 246, 0);\r\n    }\r\n\r\n    100% {\r\n        box-shadow: 0 0 0 0 rgba(59, 130, 246, 0);\r\n    }\r\n}\r\n\r\n.custom-keyboard .hg-activeButton {\r\n    animation: pulse 0.5s cubic-bezier(0.4, 0, 0.6, 1) !important;\r\n    border-color: #3b82f6 !important;\r\n    background-color: #036cb5 !important;\r\n    color: #fff\r\n}\r\n\r\n\r\n.language-button span {\r\n    filter: grayscale(1);\r\n}\r\n\r\n.move_money .tabSelector .active:first-child {\r\n    background-color: var(--primary-light)\r\n}\r\n\r\n.move_money .tabSelector .active:last-child {\r\n    background-color: var(--error-light-hover)\r\n}\r\n\r\n.ps__rail-y {\r\n    z-index: 150\r\n}\r\n\r\n/******** trade ticket custome styles ***********/\r\n.trade-ticket hr {\r\n    margin: 0.5rem 0;\r\n    color: inherit;\r\n    border: 0;\r\n    border-top: 1px dashed #a1a1a1 !important;\r\n    opacity: 1 !important;\r\n}\r\n\r\n.trade-ticket label:first-child {\r\n    background: #e6f2fa;\r\n    padding: 1px 0.5rem;\r\n    border-radius: 0.4rem;\r\n}\r\n\r\n.trade-ticket .row .col:nth-child(2) {\r\n    background-image: linear-gradient(90deg, black -290%, transparent 5%);\r\n    border-radius: 0.5rem;\r\n}\r\n\r\n.trade-ticket .row .col .row .col {\r\n    border-left: none\r\n}\r\n\r\n/********** attach icon**********/\r\n.custom-file-label::after {\r\n    content: \"\\f0c6\";\r\n    font-family: \"Font Awesome 5 Free\";\r\n    font-weight: 900;\r\n    /*font-size: large;*/\r\n    margin: 0 5px\r\n}\r\n/**************** link classes *******************/\r\n.link-style {\r\n    /*font-weight: 600;*/\r\n    /*text-decoration: underline;*/\r\n    cursor: pointer\r\n}\r\n\r\n    .link-style:hover {\r\n        font-weight: 600;\r\n        text-decoration: underline;\r\n        /*color: var(--grey-normal);*/\r\n    }\r\n\r\n\r\n.pp-table table th {\r\n    padding: 10px 5px;\r\n    border-bottom: 1px solid #0000001a\r\n}\r\n\r\n.pp-table table td {\r\n    padding: 5px\r\n}\r\n\r\n    .pp-table table td:nth-child(3) {\r\n        background: #f5d6d6;\r\n    }\r\n\r\n    .pp-table table td:nth-child(4) {\r\n        background: #ffeded;\r\n    }\r\n\r\n    .pp-table table td:nth-child(5) {\r\n        background: #fff3f3;\r\n    }\r\n\r\n    .pp-table table td:nth-child(6) {\r\n        border-top: 1px solid #e5e5e5;\r\n        background: #e7f5ff;\r\n    }\r\n\r\n    .pp-table table td:nth-child(7) {\r\n        background: #ecffec;\r\n    }\r\n\r\n    .pp-table table td:nth-child(8) {\r\n        background: #e3fbe3;\r\n    }\r\n\r\n    .pp-table table td:nth-child(9) {\r\n        background: #d2efd2;\r\n    }\r\n    /**************/\r\n\r\n.deposit-money-form .accordion-button {\r\n    padding: 5px;\r\n    font-size:0.8rem\r\n}\r\n\r\n.quote-sticky-header {\r\n    align-items: center;\r\n    background-color: #fff;\r\n    border-bottom: 1px solid #ebebeb;\r\n    column-gap: 16px;\r\n    display: flex;\r\n    height: 64px;\r\n    /*margin-top: -65px;*/\r\n    padding-left: var(--adaptive-mf-container-padding);\r\n    padding-right: var(--adaptive-mf-container-padding);\r\n    position: sticky;\r\n    top: 64px;\r\n    transform: translateY(-65px);\r\n    transition: transform .1s ease-in-out;\r\n    z-index: 98;\r\n}\r\n\r\n.quote-research p {\r\n    font-size: 12px !important;\r\n    font-weight: 700\r\n}\r\n\r\n.price-click-style:hover {\r\n    /*border: 1px solid #CC0000;*/\r\n    text-decoration:underline;\r\n    cursor: pointer;\r\n    font-weight: 700;\r\n   \r\n}\r\n\r\n.balance-card {\r\n    flex: 1;\r\n    padding: 20px;\r\n    border-radius: 8px;\r\n    text-align: center;\r\n    box-sizing: border-box;\r\n    min-width: 0;\r\n}\r\n    .balance-card.from {\r\n        border-color: #ff9800 !important;\r\n        border: 3px solid;\r\n        background: #fff8e1;\r\n    }\r\n    .balance-card.to {\r\n        border-color: !important;\r\n        border: 3px solid #4caf50;\r\n        background: #e8f5e9;\r\n    }\r\n\r\n/* warn message div */\r\n.warn-message-div {\r\n    justify-content: center;\r\n    background-color: rgb(255, 215, 185);\r\n    opacity: 1;\r\n    border-width: 2px;\r\n    border-style: dashed;\r\n    border-color: rgb(226, 94, 62);\r\n    border-radius: 8px;\r\n    padding: 10px;\r\n    margin-top: 5px;\r\n    color: rgb(51, 51, 51);\r\n    clear: both;\r\n}\r\n.validation-msg {\r\n    margin-top: 8px;\r\n    padding: 10px;\r\n    border-radius: 4px;\r\n    font-size: 14px;\r\n}\r\n\r\n.validation-msg.error {\r\n    background: #ffebee;\r\n    color: #c62828;\r\n    border: 1px solid #ef5350;\r\n}\r\n/* Price change animation */\r\n@keyframes priceFlash {\r\n    0% {\r\n        background-color: transparent;\r\n        transform: scale(1);\r\n    }\r\n\r\n    50% {\r\n        background-color: #ffd7b9;\r\n        transform: scale(1.02);\r\n    }\r\n\r\n    100% {\r\n        background-color: transparent;\r\n        transform: scale(1);\r\n    }\r\n}\r\n\r\n.price-changed {\r\n    animation: priceFlash 0.6s ease-in-out;\r\n}\r\n\r\n/* Alternative: Glow effect */\r\n@keyframes priceGlow {\r\n    0% {\r\n        box-shadow: 0 0 0px transparent;\r\n    }\r\n\r\n    50% {\r\n        box-shadow: 0 0 15px rgba(0, 121, 194, 0.6);\r\n    }\r\n\r\n    100% {\r\n        box-shadow: 0 0 0px transparent;\r\n    }\r\n}\r\n\r\n.price-changed-glow {\r\n    animation: priceGlow 0.8s ease-in-out;\r\n}\r\n\r\n@media (min-width: 576px) {\r\n    .small-modal .modal-dialog {\r\n        max-width: 30vw !important;\r\n    }\r\n\r\n    .medium-modal .modal-dialog {\r\n        max-width: 55vw !important;\r\n    }\r\n\r\n    .large-modal .modal-dialog {\r\n        max-width: 75vw !important;\r\n    }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
